import * as React from "react"
import { useTracker } from "@modules/analytics"
import { useToggleBurstBuilds } from "../hooks/useToggleBurstBuilds"
import { siteBuildsSettings as text } from "@modules/locales/default.js"
import { ToggleCheckbox } from "gatsby-interface"
import { useWorkspaceDetailsShortcuts } from "@modules/organization/builds/hooks/useWorkspaceDetailsShortcuts"

export type EnableBurstBuildsProps = {
  siteId: string
  organizationId: string
  burstModeEnabled: boolean
}

export function EnableBurstBuilds({
  siteId,
  organizationId,
  burstModeEnabled,
}: EnableBurstBuildsProps) {
  const [toggleBuilds, { errorAlert }] = useToggleBurstBuilds(siteId)
  const { trackButtonClicked } = useTracker()

  return (
    <React.Fragment>
      <ToggleCheckbox
        id="enable-burst-builds-checkbox"
        label={text.labels.enableBurstBuilds}
        hint={text.messages.increasesBuildSpeeds}
        checked={!!burstModeEnabled}
        onChange={() => {
          trackButtonClicked(`update burst builds`, {
            uiSource: `Site Settings`,
          })

          toggleBuilds()
        }}
      />
      {errorAlert}
    </React.Fragment>
  )
}
